import { useQuery } from '@apollo/client/react';

import { GET_WORK_ORDER } from '@atom/graph/work';
import { WorkOrderDetailType } from '@atom/types/work';

export type WorkOrderSidebarData = {
  workOrder: WorkOrderDetailType | undefined;
  loading: boolean;
  error: boolean;
};

const useWorkOrderSidebarData = (id: string): WorkOrderSidebarData => {
  const { loading, data, error } = useQuery(GET_WORK_ORDER, {
    variables: { id },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    skip: !id,
  });

  return {
    workOrder: data?.workOrder,
    loading: loading && !data,
    error: Boolean(error),
  };
};

export default useWorkOrderSidebarData;
